// One answer option, styled like the FinLite btn-3d buttons.
// state: 'idle' | 'correct' | 'wrong' | 'muted'
export default function AnswerButton({ label, state, disabled, onClick }) {
  const base =
    'btn-3d w-full py-6 rounded-[2rem] flex items-center justify-center gap-3 font-black uppercase tracking-widest text-sm';

  const theme = {
    idle: 'bg-slate-800 hover:bg-slate-700 text-white',
    correct: 'bg-emerald-600 text-white',
    wrong: 'bg-red-600 text-white',
    muted: 'bg-slate-800/40 text-slate-500',
  }[state || 'idle'];

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${theme}`}
    >
      {state === 'correct' && <span className="text-2xl">😊</span>}
      {label}
    </button>
  );
}
